import React, { useState, useCallback } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import NotificationPopUp from "util/NotificationPopUp";
import { Button } from "primereact/button";
import { JobInfoDTO } from "../../../serviceapi/jobRunnerApi";

interface JobRunnerProp {
  jobRunner: JobInfoDTO;
  onJobRunnerToggled(jobRunnerId?: string): void;
}

const JobRunnerToggleButton = ({
  jobRunner,
  onJobRunnerToggled,
}: JobRunnerProp) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [enabled, setEnabled] = useState<boolean | undefined>(
    jobRunner.enabled
  );

  const getJobRunnerStatusMessages = useCallback(() => {
    if (enabled) {
      return {
        notification: "Stopping Job Runner",
        tooltip: "Turn Job Runner off",
        confirmation: "Do you want to turn off the job runner?",
      };
    }
    return {
      notification: "Starting Job Runner",
      tooltip: "Turn Job Runner on",
      confirmation: "Do you want to turn on the job runner?",
    };
  }, [enabled]);

  const { notification, tooltip, confirmation } = getJobRunnerStatusMessages();

  const handleJobRunnerToggle = useCallback(async () => {
    try {
      setEnabled((prev) => !prev);
      NotificationPopUp.show(notification, "success");
      onJobRunnerToggled(jobRunner.taskId);
    } catch (error) {
      NotificationPopUp.show(
        "An error occurred while toggling the Job Runner.",
        "error"
      );
      console.error(error);
    } finally {
      setVisible(false);
    }
  }, [jobRunner.taskId, notification, onJobRunnerToggled]);

  return (
    <>
      <ConfirmDialog
        visible={visible}
        header="Confirmation"
        onHide={() => setVisible(false)}
        message={confirmation}
        icon="pi pi-exclamation-triangle"
        accept={handleJobRunnerToggle}
      />
      <Button
        icon="pi pi-power-off"
        severity={enabled ? "success" : "danger"}
        tooltip={tooltip}
        onClick={() => setVisible(true)}
      />
    </>
  );
};

export default React.memo(JobRunnerToggleButton);
